import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CreateFormGroupArgs } from '@progress/kendo-angular-grid';
import { AppService } from '../../../app.service';
import { WorkOrderScheduleEditService } from './work-order-schedule-edit.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { WorkOrderScheduleAddComponent } from './work-order-schedule-add/work-order-schedule-add.component'


const PLACEHOLDER = 'placeholder';

@Component({
    selector: 'app-work-order-schedule',
    templateUrl: './work-order-schedule.component.html',
    styleUrls: ['./work-order-schedule.component.scss'],
})

export class WorkOrderScheduleComponent implements OnInit {

    private readonly _fullScreenToggled: any;
    private readonly workOrderScheduleEditService: WorkOrderScheduleEditService;

    public fullScreenToggled = false;
    public schedulerHeight = '100%';
    public selectedDate: Date = new Date();
    public formGroup: UntypedFormGroup;
    public isVacationCreation = false;
    matDialog: MatDialog;

    constructor(
        private readonly formBuilder: UntypedFormBuilder,
        public router: Router,
        appService: AppService,
        injector: Injector
    ) {
        this.workOrderScheduleEditService = injector.get(WorkOrderScheduleEditService);
        this.matDialog = injector.get(MatDialog);

        this._fullScreenToggled = appService.fullScreenToggled.subscribe((isFullScreen) => {
            this.schedulerHeight = '100%';
            this.fullScreenToggled = isFullScreen;
        });
        this.createFormGroup = this.createFormGroup.bind(this);
    }

    ngOnInit() {
        this.workOrderScheduleEditService.read();
    }

    public createFormGroup(args: CreateFormGroupArgs): UntypedFormGroup {
        const dataItem = args.dataItem;

        this.formGroup = this.formBuilder.group({
            'Id': dataItem.Id ? dataItem.Id : '',
            'PlannedStartDate': [dataItem.PlannedStartDate, Validators.required],
            'PlannedCompletionDate': [dataItem.PlannedCompletionDate, Validators.required],
            'StudyTitle': [dataItem.StudyTitle, Validators.required],
            'AssignedEngineer': dataItem.AssignedEngineer,
            'WorkOrderId': [dataItem.WorkOrderId, Validators.required],
            'workOrderNumber': dataItem.WorkOrderNumber,
            'ProgramId': dataItem.ProgramId,
            'programCode': dataItem.ProgramCode,
            'isVacation': dataItem.isVacation,
        });
        if (!this.formGroup.controls['isVacation']) {
            this.formGroup.controls['StudyTitle'].disable();
        }
        if (this.formGroup.get('isVacation').value) {
            this.formGroup.get('WorkOrderId').setValue(PLACEHOLDER);
        }
        return this.formGroup;
    }

    workOrderSelectionChange(workOrder) {
        const selectedWorkOrder = this.workOrderScheduleEditService.workOrderServiceFilterable
            .value.find(x => x.WorkOrderId === workOrder.value);
        this.formGroup.get('StudyTitle').setValue(selectedWorkOrder.StudyTitle);
    }

    programSelectionChange() {
        this.formGroup.get('workOrderNumber').setValue(null);
        this.formGroup.get('WorkOrderId').setValue(null);
        this.formGroup.get('StudyTitle').setValue(null);
    }

    /**
     * Prevents editing on holidays.
     *
     * @param {*} event
     * @memberof WorkOrderScheduleComponent
     */
    editHandler(event: any) {
        if (this.isHoliday(event)) {
            event.preventDefault();
        } else if (this.isNotEditable(event)) {
            event.preventDefault();
        }
    }

    disableEventHandler(event: any) {
        event.preventDefault();
    }

    isNotEditable(event: any) {
        if (event.dataItem.isVacation) {
            return false;
        }
        return !event.dataItem.WorkOrderStatus || event.dataItem.WorkOrderStatus === 'Cancelled' || event.dataItem.WorkOrderStatus === 'Complete';
    }

    isHoliday(event: any) {
        return event.dataItem.isHoliday || this.workOrderScheduleEditService.isHoliday(event.dataItem.PlannedStartDate);
    }

    AddNew() {
        const dialog = WorkOrderScheduleAddComponent;
        const data = {
            title: `Assign New Schedule`,
            formGroup: addNewScheduleForm,
            yesLabel: 'Submit',
            noLabel: 'Cancel',
        };

        const dialogRef = this.matDialog.open(dialog, { data });

        dialogRef.afterClosed()
            .subscribe(result => {
                if (result) {
                    this.workOrderScheduleEditService.createSchedule(result);
                }
            });
    }

    back = () => this.router.navigate(['/VE']);

    /**
     * Switches between vacation editing.
     * True: vacation editing
     * False: work order editing
     *
     * @param {*} isVacationEditing
     * @memberof WorkOrderScheduleComponent
     */
    switchEditMode(isVacationEditing) {
        this.isVacationCreation = isVacationEditing;
        this.formGroup.get('isVacation').setValue(isVacationEditing);
        this.formGroup.get('workOrderNumber').setValue(null);
        this.formGroup.get('WorkOrderId').setValue(null);
        this.formGroup.get('ProgramId').setValue(null);
        this.formGroup.get('programCode').setValue(null);
        this.formGroup.get('StudyTitle').setValue(null);

        if (isVacationEditing && !this.formGroup.get('WorkOrderId').value) {
            this.formGroup.get('WorkOrderId').setValue(PLACEHOLDER);
        }
    }
}

export const addNewScheduleForm = {
    Id: [],
    PlannedStartDate: ['', Validators.required],
    PlannedCompletionDate: ['', Validators.required],
    StudyTitle: ['', Validators.required],
    AssignedEngineer: ['', Validators.required],
    WorkOrderId: ['', Validators.required],
    workOrderNumber: [],
    ProgramId: [],
    programCode: [],
    isVacation: [],
};
